export const formatPhoneNumber = (phoneNumber: string) => phoneNumber.replace(/(\d{2,3})(\d{3})(\d{3})(\d{3})/, "$1 $2 $3 $4");
